import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Menu, X } from "lucide-react";
import { Brand } from "./Logo";

const LINKS = [
  { href: "#accueil", label: "Accueil", testid: "nav-accueil-link" },
  { href: "#services", label: "Services", testid: "nav-services-link" },
  { href: "#galerie", label: "Galerie", testid: "nav-gallery-link" },
  { href: "#packs", label: "Packs", testid: "nav-packs-link" },
  { href: "#devis", label: "Devis en ligne", testid: "nav-booking-link" },
  { href: "#contact", label: "Contact", testid: "nav-contact-link" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
        scrolled ? "backdrop-blur-xl bg-[#0A0D14]/80 border-white/10" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <a href="#accueil" data-testid="nav-brand-link" aria-label="DIMORA — Accueil">
          <Brand />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-sm text-slate-300 hover:text-amber-300 transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href="tel:+33618907435"
            data-testid="nav-phone-button"
            className="flex items-center gap-2 text-sm font-semibold text-[#0A0D14] bg-amber-400 hover:bg-amber-300 rounded-full px-5 py-2.5 transition-all duration-300 hover:scale-[1.03] active:scale-[0.97] hover:shadow-[0_0_30px_rgba(242,193,78,0.45)]"
          >
            <Phone className="w-4 h-4" /> 06 18 90 74 35
          </a>
        </div>

        <button
          data-testid="nav-mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.25 }}
            className="lg:hidden backdrop-blur-xl bg-[#0A0D14]/95 border-t border-white/10 px-6 py-6 flex flex-col gap-5"
          >
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`${l.testid}-mobile`}
                onClick={() => setOpen(false)}
                className="text-base text-slate-200 hover:text-amber-300 transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a href="tel:+33618907435" data-testid="nav-phone-button-mobile" className="text-base font-semibold text-amber-300">
              06 18 90 74 35
            </a>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
